@let obs =
  {
    added: hasEntry$ | async,
    loading: loading$ | async,
  };

<div class="wishlist" (click)="!obs.loading && addOrRemoveEntry()">
  <div class="wishlist-icon-block">
    <sd-icon
      class="icon-size-xs icon-size-md-s icon-size-lg-m"
      [class.active]="obs.added"
      [type]="obs.added ? 'fat-heart-filled' : 'fat-heart'"
    ></sd-icon>
  </div>
</div>
